module.exports = __webpack_public_path__ + "static/media/border-bottom.a6133873.svg";